import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MCQ } from 'src/app/shared/models/exercise.model';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { MCQ } from 'src/app/models/exercise.model';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-mcq',
  templateUrl: './mcq.component.html',
  styleUrls: ['./mcq.component.css']
})
export class McqComponent {
  map: { [key: string]: boolean } = {};
  _element: MCQ;
  _answer: any;
  @Input() fixedEditor: any;
  @Output() onClick = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() isResultPublished: boolean = false;
  @Input() id: string;
  @Input() isSubmitted: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;

  
 
  @Input() index: number;
  @Input() exerciseTimetrackingdata;
  questionChecked: boolean = false;
  @Input()
  set element(element) {
    this._element = element;
    if (this._element && this._element.options && this._element.options.length) {
      this._element.options.forEach(({ _id }) => this.map[_id] = false);
    }
    if(this._answer) {
      this._answer.split(',').forEach(ans => this.map[ans] = true);
    }
  }
  @Input() set answer(answer) {
    this._answer = answer;
    if(this._answer){
      this.questionChecked = true;
      
      this._answer.split(',').forEach(ans => this.map[ans] = true);
    }
  }
  @Input() points: any;
  @Input() variableFeedback: any;


  @Input() exerciseId;
  constructor(private utilitiyService :UtilityService) { }
  selectedItems: number = 0;
  @Input() questionBlos;


  get showNextButton() {
    let selectedItems = Object.keys(this.map).filter(el => this.map[el]).length;
    if (this._element.type == 'EXACT') {
      if (selectedItems == this._element.numberOfAnswerOption)
        return true;
    } else {
      return selectedItems > 0;
    }
  }

  radioState(id) {
    Object.keys(this.map).forEach(v => this.map[v] = false)
    this.map[id] = !this.map[id];
  }
  checkedState(event, id) {
    // ;
    let selectedItems = Object.keys(this.map).filter(el => this.map[el]).length;
    if (event.target.checked === true) {
      if (selectedItems < this._element.numberOfAnswerOption) {
        this.map[id] = true;
      } else {
        event.target.checked = false;
      }
    } else if (selectedItems > 0) {
      this.map[id] = false;
    }
  }

  next() {
    
    this.onClick.emit({ elementId: this.id, answer: this.compileAnswers() });
  }

  check() {
    let obj = { elementId: this.id, answer: this.compileAnswers() }
    this.utilitiyService.evaluateQuestion({exerciseId:this.exerciseId,answers:obj}).subscribe(data=>{
      if(data){
        this.variableFeedback = data.answerFeedback
        this.questionChecked = true; 
        this.onReview.emit(obj);
      }
    });
  }

  skip() {
    this.onClick.emit({ elementId: this.id, answer: '' });
  }

  backHandler() {
    this.back.emit(true);
  }

  compileAnswers() {
    return Object.keys(this.map).filter(k => this.map[k]).join(',');
  }

  get questionAttempted() {
    return Object.keys(this.map).some(el => this.map[el]);
  }

  ngOnInit() {
    // console.log('qsblo', this.questionBlos);
    
  }

  _reportFeedback(value) {
    this.reportFeedback.emit(value);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }
}
